import {
  ComponentFactory,
  ComponentFactoryResolver, Injectable, NgModuleFactory, NgModuleRef, SystemJsNgModuleLoader, Type,
  ViewContainerRef
} from '@angular/core';
import {AppModule} from './app.module';

@Injectable()
export class AppService {

  constructor(private moduleLoader: SystemJsNgModuleLoader, private appModuleRef: NgModuleRef<AppModule>) {
  }

  loadComponent(compPath: string, con: ViewContainerRef): Promise<any> {
    const p = new Promise((resolve, reject) => {
      const idx = compPath.lastIndexOf('.');
      const modpath = compPath.substring(0, idx);

      const comp = compPath.substring(idx + 1);
      if (modpath.startsWith('app/app.module')) {
        const aa: ComponentFactoryResolver = this.appModuleRef.componentFactoryResolver;
        let testtype: Type<any>;
        (aa as any)._factories.forEach((gg, index, map) => {

            testtype = gg.componentType;

            // console.log(gg.selector);
            if (String(gg.selector) === String(comp)) {
              const xx: ComponentFactory<any> = aa.resolveComponentFactory(testtype);

              resolve(con.createComponent(xx));
            }
          }
        );
      } else {
        this.moduleLoader.load(modpath).then(
          (factory: NgModuleFactory<any>) => {

            const aa: ComponentFactoryResolver = factory.create(this.appModuleRef.injector).componentFactoryResolver;

            let testtype: Type<any>;
            (aa as any)._factories.forEach((gg, index, map) => {

                testtype = gg.componentType;

                // console.log(gg.selector);
                if (String(gg.selector) === String(comp)) {
                  const xx: ComponentFactory<any> = aa.resolveComponentFactory(testtype);
                  const acon = con.createComponent(xx);
                  resolve(acon);
                }
              }
            );
          }
        );
      }

    });
    return p;
    // 动态载加模块和组件2

  }

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app.service.ts